import React, { useEffect, useRef, useState } from 'react'
import IconCancel from 'shared/icons/cancel'

/**
 * Component for displaying toaster notifications.
 * @returns {JSX.Element | null} Toaster component
 */
function Toaster() {
  const [isVisible, setIsVisible] = useState({ isOpen: false })
  const data = useRef({})

  function handleClose() {
    setIsVisible({ isOpen: false })
  }

  useEffect(() => {
    function handleChange({ detail }) {
      data.current = detail
      setIsVisible({ isOpen: true })
      setTimeout(() => {
        handleClose()
      }, 5000)
    }
    window.addEventListener('toasterEvent', handleChange)
    return () => window.removeEventListener('toasterEvent', handleChange)
  }, [])

  if (isVisible.isOpen) {
    return (
      <div
        className={`w-100 max-w-[90%] text-md flex items-center text-light gap-2 px-4 py-2.5 fixed end-0 md:top-8 xl:top-14 z-50 shadow-error-box rounded-md rounded-e-none shadow-card
        ${data.current?.eType === 's' ? 'bg-accent-success' : 'bg-accent-danger'} `}
        role="alert"
      >
        <p className="m-0 grow font-semibold">{data.current?.msg}</p>
        <button
          type="button"
          className="ms-auto inline-flex items-center flex-shrink-0 text-light justify-center h-5 w-5"
          data-dismiss-target="#toast-undo"
          aria-label="Close"
          onClick={handleClose}
        >
          <IconCancel />
        </button>
      </div>
    )
  } else return null
}
export default Toaster
